<template>
    <div class="welcome">
        <div class="welcome__greeting">
            <h1>Welcome to the goTenna Pro Management Portal</h1>
            <p class="copy">
                This is your all-in-one dashboard for setting up users, frequency sets, and groups for use out in the
                field.
            </p>

            <router-link
                tag="button"
                :to="`/onboarding/admin/${token}/set-password`"
                class="btn btn-primary"
            >
                Continue <span class="icon-arrow-right"></span>
            </router-link>
        </div>

        <img
            src="/images/pro-device.png"
            alt="goTenna Pro"
            class="welcome__decorator"
        />
    </div>
</template>

<script>
export default {
    props: ['token'],

    mounted() {
        this.$emit('step', 1)
    },
}
</script>
